import { render, staticRenderFns } from "./Representative.vue?vue&type=template&id=582d8e93&"
import script from "./Representative.vue?vue&type=script&lang=js&"
export * from "./Representative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports